import { serviceLogMatrixPath } from './constants';
import { baseAutomationUrl } from 'src/config';
import { getAccessToken, getRealmName } from 'src/routes/AuthContext';
import { IServiceLogGetParams } from './types';
import axios from 'axios';

export const getPullServiceLog = async (body: IServiceLogGetParams) => {
  const token = await getAccessToken();
  const realm = getRealmName() ?? '';
  const getFacilityUuid = localStorage.getItem('facilityId');

  if (getFacilityUuid && getFacilityUuid.length) {
    body.facility_uuid = getFacilityUuid;
  }

  body.enterprise_name = realm;

  const url = `${baseAutomationUrl}${serviceLogMatrixPath.PULL_SERVICE_LOG}`;

  return axios.post(url, body, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: 'arraybuffer',
  });
};
